// extracted by mini-css-extract-plugin
module.exports = {"TEIDLogo":"TEIDLogo_TEIDLogo__gB4si","Link":"TEIDLogo_Link__1yp6j"};